module.exports = __webpack_public_path__ + "img/button-selected.23ca009b.svg";